export type JwtPayload = {
    platformSuperAdmin?: boolean;
    email?: string;
    userId?: string;
};

export function getJwtPayload(token: string | null | undefined): JwtPayload | null {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length < 2) return null;
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const json = atob(padded);
        return JSON.parse(json) as JwtPayload;
    } catch {
        return null;
    }
}
